import * as types from "../types";
import KycSelect from "../../services/KycSelect.Service";
import { funcUpdateAppStateAfterResponse } from "./AppStateActions";
const initState = {
    isSaved: true,
    currentAction: "",
    isSubmited: false,
    isSubmitedSuccess: false,
    loading: false,
    error: null,
    eKycEngineResDecpFailSts: false
};
let payload = {};
let errorState = {};

export const fetchEkycEngineEncryptedReqParam = (reqPayload) => async (dispatch) => {
    dispatch({
        type: types.LOADING_VIEW_STATE,
        value: true,
    });
    const response = await KycSelect.funcEkycRedirectEncryptedReqParam(/*JSON.stringify(JSON.parse(*/reqPayload/*))*/);
    if (response) {
        if (response.statusCode === "000") {
            // localStorage.setItem("hsToken",response.hsToken)
            payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: true,
            };
            errorState = null;
            dispatch({
                type: types.SAVE_EKYC_REDIRECT_ENCRYPTED_DATA,
                payload: { enc:  response.data},
            });
        } else {
            payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: false,
            };
            errorState = {
                errorCode: response.statusCode,
                errorMsg: response.message,
            };
        }
    } else {
        payload = {
            ...initState,
            isSubmited: true,
            loading: false,
            isSubmitedSuccess: false,
            error: response.data?.message,
        };
        errorState = {
            errorCode: response.statusCode,
            errorMsg: response.message,
        };
    }
    dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
}

export const fetchEkycEngineDecryptedReqParam = (reqPayload) => async (dispatch) => {
    dispatch({
        type: types.LOADING_VIEW_STATE,
        value: true,
    });
    const response = await KycSelect.funcEkycRedirectDecryptedReqParam({...reqPayload,
      action: "decEKYC",
      type: "Swift App"});
   
    if (response) {
        if (response.statusCode === "000") {
            //localStorage.setItem("hsToken",response.hsToken)
            payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: true,
            };
            errorState = null;
            dispatch({
                type: types.SAVE_EKYC_REDIRECT_DECRYPTED_DATA,
                payload: { dec:  response},
            });
        } else {
            payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: false,
                eKycEngineResDecpFailSts: true,
            };
            errorState = {
                errorCode: response.statusCode,
                errorMsg: response.message,
            };
        }
    } else {
        payload = {
            ...initState,
            isSubmited: true,
            loading: false,
            isSubmitedSuccess: false,
            error: response.data?.message,
        };
        errorState = {
            errorCode: response.statusCode,
            errorMsg: response.message,
        };
    }
    dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
}


export const funcGetEkycAddress = (reqPayload , ckycFlag) => async(dispatch) => {
    dispatch({
        type: types.LOADING_VIEW_STATE,
        value: true,
    });
    const response = await KycSelect.funcGetEkycAddress(reqPayload);
    if (response) {
        if (response.statusCode === "000") {
            if(ckycFlag && response?.data?.kycValid === null){
                payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: false,
            };
            errorState = {
                errorCode: response.statusCode,
                errorMsg: response.message,
            };
            }
            else{
            payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: true,
            };
            dispatch({
                type: types.SAVE_EKYC_DATA,
                payload: response.data,
            });
            dispatch({
                    type: types.SAVE_DIGILOCKER_DATA,
                    payload: response.data,
            });
            errorState = null;
            }
        } else {
            payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: false,
            };
            errorState = {
                errorCode: response.statusCode,
                errorMsg: response.message,
            };
        }
    } else {
        payload = {
            ...initState,
            isSubmited: true,
            loading: false,
            isSubmitedSuccess: false,
            error: response.data?.message,
        };
        errorState = {
            errorCode: response.statusCode,
            errorMsg: response.message,
        };
    }
    dispatch(funcUpdateAppStateAfterResponse(payload, errorState));

}

export const funcCkycOtpGen = (reqPayload,currentAction,resendFlag) => async(dispatch) => {
    dispatch({
        type: types.LOADING_VIEW_STATE,
        value: true,
    });
    const response = await KycSelect.funcCkycOtpGen(reqPayload,resendFlag);
    if (response) {
        if (response.data.statusCode === "000") {
            dispatch({ type: types.SAVE_CKYC_KIN_NUMBER, payload: {ckycOtpGenRequestId : response?.data?.data?.requestId, kinNumber : reqPayload.ckycNo} });
            if (!resendFlag) {
                payload = {
                    ...initState,
                    currentAction,
                    isSubmited: true,
                    isSubmitedSuccess: true,
                    // screenName: screenName,
                    loading: false,
                };
            } else {
                payload = {
                    ...initState,
                    currentAction,
                    // screenName: screenName,
                    loading: false,
                };
            }
            // payload = {
            //     ...initState,
            //     currentAction: currentAction,
            //     isSubmited: true,
            //     loading: false,
            //     isSubmitedSuccess: true,
            // };
            // errorState = null;
            // if(currentAction!=="resendCkycOtp")
            // dispatch({ type: types.SAVE_CKYC_DATA, payload: {kinNumber : reqPayload.ckycNo} });
        } else {
            payload = {
                ...initState,
                currentAction: currentAction,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: false,
            };
            errorState = {
                errorCode: response.data.statusCode,
                errorMsg: response.message,
            };
        }
    } else {
        payload = {
            ...initState,
            currentAction: currentAction,
            isSubmited: true,
            loading: false,
            isSubmitedSuccess: false,
            error: response.data?.message,
        };
        errorState = {
            errorCode: response.data.statusCode,
            errorMsg: response.message,
        };
    }
    dispatch(funcUpdateAppStateAfterResponse(payload, errorState));

}

export const funcvalidateCKycOTP = (otpInput, currentAction) => async (dispatch) => {
    dispatch({
        type: types.LOADING_VIEW_STATE,
        value: true,
    });
    const response = await KycSelect.funcvalidateCKycOTP(otpInput);
    if (response) {
        if (response.statusCode === "000") { 
            payload = {
                ...initState,
                currentAction: currentAction,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: true,
            };
            errorState = null;
        } else {
            payload = {
                ...initState,
                currentAction:currentAction,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: false,
            };
            errorState = {
                errorCode: response.statusCode,
                errorMsg: response.message,
            };
        }
    } else {
        payload = {
            ...initState,
            currentAction: currentAction,
            isSubmited: true,
            loading: false,
            isSubmitedSuccess: false,
            error: response.data?.message,
        };
    }
    dispatch(funcUpdateAppStateAfterResponse(payload, errorState));
}
/*
export const funcReKycIntimation = (reqPayload, action) => async(dispatch) => {
    dispatch({
        type: types.LOADING_VIEW_STATE,
        value: true,
    });
    const response = await MidMitcService.finalSubmission(reqPayload, action);
    if (response.data) {
        if (response.data.statusCode === "000") {
            payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: true,
                reKycIntimation: true,
            };
            errorState = null;
        } else {
            payload = {
                ...initState,
                isSubmited: true,
                loading: false,
                isSubmitedSuccess: false,
              //  reKycIntimation: false,
            };
            errorState = {
                errorCode: response.data?.statusCode,
                errorMsg: response.data?.message,
            };
        }
    } else {
        payload = {
            ...initState,
            isSubmited: true,
            loading: false,
            isSubmitedSuccess: false,
            error: response.data?.message,
        };
        errorState = {
            errorCode: response.data?.statusCode,
            errorMsg: response.data?.message,
        };
    }
    dispatch(funcUpdateAppStateAfterResponse(payload, errorState));

}*/